import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Container } from '../../atoms';
import { ImageGallery } from '../../molecules';
export default function ImageGallerySection(param) {
    var images = param.images, accentColor = param.accentColor, className = param.className;
    return /*#__PURE__*/ React.createElement(Container, {
        name: ImageGallerySection.name,
        className: twMerge('overflow-hidden', className)
    }, /*#__PURE__*/ React.createElement(ImageGallery, {
        images: images,
        accentColor: accentColor
    }));
}

//# sourceMappingURL=ImageGallerySection.js.map